/**
 * @generated SignedSource<<7f78824aec5ca4be031f8353bfdc68fb>>
 * @relayHash b7b68150dc1fb4c31759bb289f3a3a3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 78b2171f000f718cf91bc0695b6e0b8b9dbb60cc432797a70d48f99027397d9f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessCalendarEmbedQuery } from './src_jiraBusinessCalendarEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessCalendarEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "78b2171f000f718cf91bc0695b6e0b8b9dbb60cc432797a70d48f99027397d9f",
    "metadata": {},
    "name": "src_jiraBusinessCalendarEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
